"use client"

import type { ReactNode } from "react"
import Link from "next/link"

import { trackLibraryBrowseClick, trackToolEntryCtaClick } from "@/lib/analytics"

interface CreateHubLinkProps {
  href: string
  className: string
  source: string
  children: ReactNode
  ariaLabel?: string
  tool?: "converter" | "voice_generator"
  mode?: "tool" | "library"
}

export function CreateHubLink({
  href,
  className,
  source,
  children,
  ariaLabel,
  tool,
  mode = "tool",
}: CreateHubLinkProps) {
  return (
    <Link
      href={href}
      aria-label={ariaLabel}
      onClick={() => {
        if (mode === "library") {
          trackLibraryBrowseClick(source)
          return
        }

        if (!tool) return

        trackToolEntryCtaClick({
          source,
          tool,
          destination: href,
        })
      }}
      className={className}
    >
      {children}
    </Link>
  )
}
